/*eslint-disable*/
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink, useLocation } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from '@material-ui/core/Collapse';
import Icon from "@material-ui/core/Icon";
// @material-ui/icon components
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
// core components
import AdminNavbarLinks from "components/Navbars/AdminNavbarLinks.js";
import RTLNavbarLinks from "components/Navbars/RTLNavbarLinks.js";

import styles from "assets/jss/material-dashboard-react/components/sidebarStyle.js";

const useStyles = makeStyles(styles);

export default function Sidebar(props) {
  const classes = useStyles();
  const [newOpen, setNewOpen] = React.useState(true);

  const handleNewClick = () => {
      setNewOpen(!newOpen);
      return false;
  };

  const shouldNavigate = (event, hasChild) => {
      if( hasChild ) {
          event.preventDefault();
          return false;
      }
  };

  // verifies if routeName is the one active (in browser input)
  function activeRoute(routeName, parentItem = "") {
    if( parentItem === "" ) {
        return window.location.href.indexOf(routeName) > -1 ? true : false;
    }
    else {
        let location = useLocation();
        return location.pathname === routeName ? true : false;
    }
  }

  function getMenuFormattedRouteList(routes) {
      let formatted = [];
      let childItems = [];

      for (let i = 0; i < routes.length; i++) {
          if( routes[i].layout !== '/admin' ) {
              continue;
          }

          if( routes[i].parent !== "" ) {
              childItems.push(routes[i]);
          }
          else {
              formatted.push(routes[i]);

              if( routes[i].hasChild ) {
                  formatted = formatted.concat(childItems);
                  childItems = [];
              }
          }
      }

      return formatted;
  }

  function formatMenuItem( route_item, key, listItemClasses, whiteFontClasses ) {
      let activePro = " ";

      return (
          <NavLink
              to={route_item.layout + route_item.path}
              className={activePro + classes.item + activePro + (route_item.parent !== "" ? classes.subMenuItem : "")}
              activeClassName="active"
              key={key}
              onClick={(e) => shouldNavigate(e, route_item.hasChild)}
          >
              <ListItem button className={classes.itemLink + listItemClasses} onClick={route_item.hasChild ? handleNewClick : undefined}>
                  {typeof route_item.icon === "string" ? (
                      <Icon
                          className={classNames(classes.itemIcon, whiteFontClasses, {
                              [classes.itemIconRTL]: route_item.rtlActive
                          })}
                      >
                          {route_item.icon}
                      </Icon>
                  ) : (
                      <route_item.icon
                          className={classNames(classes.itemIcon, whiteFontClasses, {
                              [classes.itemIconRTL]: props.rtlActive
                          })}
                      />
                  )}
                  <ListItemText
                      primary={props.rtlActive ? route_item.rtlName : route_item.name}
                      className={classNames(classes.itemText, whiteFontClasses, {
                          [classes.itemTextRTL]: props.rtlActive
                      })}
                      disableTypography={true}
                      style={route_item.hasChild ? {display: "inline-block"} : {}}
                  />
                  {route_item.hasChild ? (newOpen ? <ExpandLess className={classes.expandCollapseIcon} /> : <ExpandMore className={classes.expandCollapseIcon} />) : ""}
              </ListItem>
          </NavLink>
      );
  }

  const { color, logo, image, logoText, routes } = props;
  let childItems = {};
  let menuFormattedRoute = getMenuFormattedRouteList(routes);
  var links = (
    <List className={classes.list}>
      {menuFormattedRoute.map((prop, key) => {
        var activePro = " ";
        var listItemClasses;

        if( prop.parent !== "" ) {
            if (Object.getOwnPropertyNames(childItems).length > 0) {
                let temp = childItems;
                childItems = {};
                return temp;
            }

            return;
        }

        listItemClasses = classNames({
            [" " + classes[color]]: activeRoute(prop.layout + prop.path)
        });
        const whiteFontClasses = classNames({
          [" " + classes.whiteFont]: activeRoute(prop.layout + prop.path)
        });

        if( prop.hasChild ) {
            let subItems = [];

            for (let i = 0; i < menuFormattedRoute.length; i++) {
                let cur_route = menuFormattedRoute[i];

                if (cur_route.path.startsWith(prop.path + "/")) {
                    let childListItemClasses = classNames({
                        [" " + classes[color]]: activeRoute(cur_route.layout + cur_route.path, cur_route.parent)
                    });
                    let childWhiteFontClasses = classNames({
                        [" " + classes.whiteFont]: activeRoute(cur_route.layout + cur_route.path, cur_route.parent)
                    });

                    subItems.push(formatMenuItem(cur_route, i, childListItemClasses, childWhiteFontClasses));
                }
            }
            childItems = (
                <Collapse in={newOpen} timeout="auto" unmountOnExit key="999">
                    {subItems}
                </Collapse>
            );
        }

        return formatMenuItem(prop, key, listItemClasses, whiteFontClasses);
      })}
    </List>
  );
  var brand = (
    <div className={classes.logo}>
      <a
        href="/admin/dashboard"
        className={classNames(classes.logoLink, {
          [classes.logoLinkRTL]: props.rtlActive
        })}
        target="_blank"
      >
        <div className={classes.logoImage}>
          <img src={logo} alt={logoText} className={classes.img} />
        </div>
      </a>
    </div>
  );

  return (
    <div>
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          anchor={props.rtlActive ? "left" : "right"}
          open={props.open}
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive
            })
          }}
          onClose={props.handleDrawerToggle}
          ModalProps={{
            keepMounted: true // Better open performance on mobile.
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>
            {props.rtlActive ? <RTLNavbarLinks /> : <AdminNavbarLinks />}
            {links}
          </div>
          {image !== undefined ? (
            <div
              className={classes.background}
              style={{ backgroundImage: "url(" + image + ")" }}
            />
          ) : 
            <div
              className={classes.background}
            />
          }
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <Drawer
          anchor={props.rtlActive ? "right" : "left"}
          variant="permanent"
          open
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive
            })
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>{links}</div>
          {image !== undefined ? (
            <div
              className={classes.background}
              style={{ backgroundImage: "url(" + image + ")" }}
            />
          ) : 
            <div
              className={classes.background}
            />
          }
        </Drawer>
      </Hidden>
    </div>
  );
}

Sidebar.propTypes = {
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  bgColor: PropTypes.oneOf(["purple", "blue", "green", "orange", "red"]),
  logo: PropTypes.string,
  image: PropTypes.string,
  logoText: PropTypes.string,
  routes: PropTypes.arrayOf(PropTypes.object),
  open: PropTypes.bool
};
